"use client";
import { jsx as e } from "react/jsx-runtime";
import { memo as l } from "react";
import c from "../components/Icon/SvgIcon.js";
const t = (o) => /* @__PURE__ */ e(
  c,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.31 15.621c0-.185.082-.361.225-.48a6.14 6.14 0 0 0 2.215-4.725c0-3.4-2.767-6.166-6.167-6.166H9.416a6.17 6.17 0 0 0-6.166 6.166 6.173 6.173 0 0 0 6.167 6.167l4.983-.001c.165 0 .324.066.442.183l3.478 3.465zM14.583 3C18.673 3 22 6.328 22 10.416c0 2.1-.885 4.083-2.439 5.489l.01 4.63a1.12 1.12 0 0 1-1.123 1.126c-.302 0-.584-.119-.796-.333l-3.51-3.496-4.725.001C5.327 17.833 2 14.506 2 10.416 2 6.328 5.327 3 9.416 3zm-8.997 7.497a1.502 1.502 0 1 0 3.003 0 1.502 1.502 0 0 0-3.003 0m4.912 0a1.503 1.503 0 1 0 3.005-.001 1.503 1.503 0 0 0-3.005.001M16.913 12a1.503 1.503 0 0 1 0-3.003 1.501 1.501 0 1 1 0 3.003",
        clipRule: "evenodd"
      }
    )
  }
), d = l(t);
export {
  d as Feedback,
  d as default
};
